module.exports = __webpack_public_path__ + "media/mtm_receive.a69bb55b.wav";